import { Box } from '@mui/material';
import { ComingSoon } from './ComingSoon';
import { Sidebar } from './Sidebar';
import { SIDEBAR_SECTIONS } from './sidebarSections';
import { HEIGHT_BELOW_BARS } from '../../core/bannerOffset';

export function ComingSoonPage() {
  return (
    <Box sx={{ display: 'flex', minHeight: HEIGHT_BELOW_BARS, bgcolor: '#F6F6F8' }}>
      <Sidebar sections={SIDEBAR_SECTIONS} />
      <Box
        sx={{
          flex: 1,
          p: { xs: 3, md: 5 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ComingSoon />
      </Box>
    </Box>
  );
}
